import { TagValues } from "@/model/data/Tag";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { IFilterInstallations } from "../supportObjects/IFilterInstallations";
import { IPaginationFilter } from "../supportObjects/IPaginationFilter";
import { GetOfflineInstallationsResData } from "./GetOfflineInstallationsResData";

const ENDPOINT = "/device/offline";

export class GetOfflineInstallationsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: GetOfflineInstallationsReqData;

    constructor(payload: GetOfflineInstallationsReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<GetOfflineInstallationsResData> {
        let res = await this.executeCommand(this.payload);
        return new GetOfflineInstallationsResData(res);
    }
}

export class GetOfflineInstallationsReqData implements IPaginationFilter, IFilterInstallations {
    installationNames: string[];
    folderIds: number[];
    branchNames: string[];

    // PaginationFilters
    queryLimit: number = 0;
    offset: number = 0;
    orderBy: string[] = null;
    orderByDescending: boolean[] = null;

    installationPrefix: string = null;
    tagValues: TagValues = null;
    machineModels: string[] = null;
}
